const CryptoJS = require('crypto-js');
var utils = function(){}


utils.Decrypt = function (word) {
  var bytes = CryptoJS.AES.decrypt(word.toString(), CryptoJS.enc.Utf8.parse("6nmcmULZQj5BbZlK"), {
    iv: CryptoJS.enc.Utf8.parse('gfGKOiYK8cXf6mqy'),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return bytes.toString(CryptoJS.enc.Utf8);
}

utils.getProtocol = function () {
  var LocalProtocol = window.location.protocol;
  return LocalProtocol;
};

utils.getParamsByHash = function () {
  return window.location.hash.match(/[^\/\?\=\&]+(?=($|\?))/)[0];
};

utils.getHiddenStr = function (number) {
  if(typeof number === 'number')
    number = number.toString();
  return new Array(number.length+1).join('•');
};

utils.formatDateTime = function(mill){
  if(!mill)
    return '';
  var date = new Date(mill) ;
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  var D = (date.getDate()< 10 ?'0'+date.getDate():date.getDate())+ ' ';
  var h = (date.getHours()< 10 ?'0'+date.getHours():date.getHours())+ ':';
  var m = (date.getMinutes()< 10 ?'0'+date.getMinutes():date.getMinutes());
  return Y+M+D+h+m;
}

utils.extendJSON = function(json1,json2){
  if(!json2)
    return json1;
  for(var key in json1){
    if(!json1[key] || typeof json1[key] !== 'object'){
      if(json2[key])
        json1[key] = json2[key];
    }else if(Array.isArray(json1[key])){
      if(json2[key] && json2[key].length > 0)
         json1[key] = json2[key] ;
        // json1[key].replace(json2[key])
    }else{
      json1[key] = utils.extendJSON(json1[key],json2[key])
    }
  }
  return json1 ;
}

utils.getParamFromURL = function(key){
  var url_params = window.location.hash;
  var regExpStr = '(?:'+key+'=)\\s*(([^\\?\\&\\=\\;])+)';
  var arr = decodeURIComponent(url_params).match(new RegExp(regExpStr));
  if(arr && arr[1]){
    return arr[1];
  }
  return '';
}


export default utils;
